"use client";

import React from "react";
import { Target, Eye, ShieldCheck, Cog } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillarsData = [{
  title: "¿Quiénes somos?",
  icon: Target,
  description: "RUDICH GROUP es una empresa desarrolladora e inmobiliaria integral que se especializa en el desarrollo, construcción y gestión de proyectos residenciales y comerciales en Buenos Aires. Nos enfocamos en ofrecer soluciones constructivas de alta calidad, con una mirada moderna y sustentable, hacer crecer e innovar"
}, {
  title: "Visión",
  icon: Eye,
  description: "Nuestra diferencia radica en la gestión profesional y personalizada de cada proyecto, la transparencia en los procesos y la calidad constructiva. Combinamos visión arquitectónica, planificación financiera y ejecución eficiente, garantizando resultados que maximizan la inversión y mantienen altos estándares estéticos y técnicos."
}, {
  title: "Excelencia en el Diseño",
  icon: ShieldCheck,
  description: "",
  list: ["Excelencia en el Diseño", "Transparencia y Ética", "Calidad Constructiva Premium", "Compromiso con el Inversor"]
}];
export default function TrayectoriaYValores() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: pillarsRef,
    isVisible: arePillarsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="nuestra-trayectoria" className="relative py-24 text-foreground overflow-hidden !bg-[hsl(0,0%,96%)]">
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] dark:opacity-[0.05]" style={{
      backgroundImage: `linear-gradient(to right, var(--color-foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)`,
      backgroundSize: "40px 40px"
    }}>
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-20 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-none text-xs font-bold mb-6 uppercase tracking-[0.2em] !bg-transparent !text-[hsl(42,50%,70%)]">
            <Cog className="w-4 h-4 animate-[spin_6s_linear_infinite]" />
            Nuestro Legado
          </div>

          <h2 className="text-4xl font-default font-bold tracking-tight mb-6 !font-serif !text-[hsl(42,50%,70%)] md:text-5xl">
            Valores y Trayectoria
          </h2>

          <p className="text-lg font-default !font-serif !text-[hsl(203,55%,13%)]">
            Más de una década transformando el paisaje urbano de Argentina con proyectos de inversión y construcción de alta gama, definidos por la precisión y el diseño exclusivo.
          </p>
        </div>

        <div ref={pillarsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12 transition-all duration-1000 delay-300 ${arePillarsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
          {pillarsData.map((pillar, index) => <Card key={index} data-index={index} className="text-card-foreground flex flex-col gap-6 py-6 px-6 backdrop-blur-md relative overflow-hidden group transition-all duration-300 rounded-[28px] border border-[#D9C28E]/35 shadow-[0_24px_60px_rgba(0,0,0,0.22)] hover:-translate-y-1 hover:shadow-[0_28px_70px_rgba(0,0,0,0.30)] !bg-[radial-gradient(circle_at_top_left,rgba(217,194,142,0.28),rgba(217,194,142,0.12)_45%,rgba(15,37,51,0.10)_100%)]">
              <div className="absolute -right-10 -top-10 w-64 h-64 rounded-full blur-3xl bg-[#D9C28E]/10 group-hover:bg-[#D9C28E]/20 transition-colors duration-500"></div>

              <div className="absolute bottom-0 right-0 opacity-40 pointer-events-none text-[#D9C28E] drop-shadow-[0_0_20px_rgba(217,194,142,0.35)]">
                <svg width="220" height="220" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id={`goldGradient-${index}`} x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stopColor="#F3DEB0" />
                      <stop offset="50%" stopColor="#D9C28E" />
                      <stop offset="100%" stopColor="#B08A4D" />
                    </linearGradient>
                  </defs>

                  <path d="M25 110C55 105 85 75 100 30" stroke={`url(#goldGradient-${index})`} strokeWidth="2" strokeLinecap="round" />
                  <path d="M36 102C30 96 26 90 24 82C33 84 40 89 45 96" fill={`url(#goldGradient-${index})`} opacity="0.65" />
                  <path d="M50 92C44 86 40 78 39 70C48 73 55 79 60 86" fill={`url(#goldGradient-${index})`} opacity="0.65" />
                  <path d="M63 78C58 70 56 62 57 54C65 59 71 66 74 74" fill={`url(#goldGradient-${index})`} opacity="0.65" />
                  <path d="M76 61C72 53 71 45 74 37C81 43 85 51 87 60" fill={`url(#goldGradient-${index})`} opacity="0.65" />
                  <path d="M89 43C86 35 87 27 91 20C97 28 100 36 99 45" fill={`url(#goldGradient-${index})`} opacity="0.65" />
                </svg>
              </div>

              <CardHeader className="pb-4 relative z-10">
                <div className="w-14 h-14 rounded-none flex items-center justify-center mb-6 group-hover:scale-105 transition-transform duration-300 !bg-transparent">
                  <pillar.icon className="w-7 h-7 !text-[hsl(21,30%,54%)]" />
                </div>

                <CardTitle className="text-2xl font-default font-bold tracking-tight !font-serif !text-[hsl(203,55%,13%)]">
                  {pillar.title}
                </CardTitle>

                <div className="w-14 h-[2px] mt-4 bg-[#D9C28E]/70 rounded-full"></div>
              </CardHeader>

              <CardContent className="px-6 pt-2 pb-8 relative z-10 !text-[hsl(0,0%,96%)]">
                {pillar.description ? <p className="font-default leading-relaxed !font-serif !bg-transparent !text-[hsl(203,55%,13%)]">
                    {pillar.description}
                  </p> : <ul className="space-y-4 mt-2">
                    {pillar.list?.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                        <div className="mt-1.5 w-3 h-3 rounded-none bg-[hsl(21,30%,54%)]/20 flex items-center justify-center shrink-0">
                          <div className="w-1.5 h-1.5 bg-[hsl(21,30%,54%)] rounded-none"></div>
                        </div>
                        <span className="font-default font-medium !font-serif !text-[hsl(203,55%,13%)]">
                          {item}
                        </span>
                      </li>)}
                  </ul>}
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}